/**
 * Brandner Auction End Animations
 *
 * Animations when auctions end:
 * - Winner: Golden confetti + trophy celebration
 * - Others: Grayscale transition + BEENDET banner
 *
 * @version 1.0.0
 */
(function($) {
    'use strict';

    var BrandnerAuctionAnimations = {
        // Konfetti-Farben
        confettiColors: ['#ffd700', '#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#ffeaa7', '#ff9ff3', '#fff'],

        // Bereits animierte Auktionen tracken (verhindert Wiederholung)
        animatedAuctions: {},

        /**
         * Initialisiert das Animations-System
         */
        init: function() {
        },

        /**
         * Zeigt die Gewinner-Animation auf einer Karte
         * @param {jQuery} card - Die Auktions-Card
         * @param {jQuery} productLi - Das umgebende LI-Element
         */
        showWinnerAnimation: function(card, productLi) {
            var productId = card.data('product-id');
            if (this.animatedAuctions[productId]) return;
            this.animatedAuctions[productId] = true;

            var self = this;

            // Winner Overlay erstellen
            var overlay = $('<div class="brandner-winner-overlay"></div>');
            var goldenRays = $('<div class="brandner-golden-rays"></div>');
            var content = $('<div class="brandner-winner-content">' +
                '<div class="brandner-winner-trophy">&#127942;</div>' +
                '<div class="brandner-winner-text">GEWONNEN!</div>' +
                '<div class="brandner-winner-subtext">Herzlichen Glückwunsch!</div>' +
                '</div>');

            overlay.append(goldenRays);
            overlay.append(content);

            // Overlay zur Karte hinzufuegen (relativ zur product-inner oder li).
            // NICHT an die kleine .brandner-auction-card-bid haengen: die hat
            // overflow:hidden und ist niedriger als der Overlay-Inhalt -> Trophy
            // und Text wurden oben/unten abgeschnitten.
            var container = productLi.find('.product-inner');
            if (container.length === 0) {
                container = productLi;
            }
            if (container.length === 0) {
                container = card;
            }
            container.css('position', 'relative');
            container.append(overlay);

            // Konfetti erzeugen
            this.createConfetti(overlay, 50);

            // Sparkles erzeugen
            this.createSparkles(overlay, 20);

            // Animation starten
            setTimeout(function() {
                overlay.addClass('active');
            }, 50);

            // Nach 5 Sekunden ausblenden
            setTimeout(function() {
                overlay.addClass('fade-out');
                setTimeout(function() {
                    overlay.remove();
                }, 500);
            }, 5000);
        },

        /**
         * Zeigt die Beendet-Animation auf einer Karte
         * @param {jQuery} card - Die Auktions-Card
         * @param {jQuery} productLi - Das umgebende LI-Element
         */
        showEndedAnimation: function(card, productLi) {
            var productId = card.data('product-id');
            if (this.animatedAuctions[productId]) return;
            this.animatedAuctions[productId] = true;

            // Flash-Effekt
            var flash = $('<div class="brandner-ending-flash"></div>');
            var container = productLi.find('.product-inner');
            if (container.length === 0) {
                container = productLi;
            }
            if (container.length === 0) {
                container = card; // Fallback: sonst verpufft der Flash unsichtbar
            }
            container.css('position', 'relative');
            container.append(flash);

            // Phase 1: Flash
            setTimeout(function() {
                flash.addClass('active');
            }, 50);

            // Phase 2: Graustufen
            setTimeout(function() {
                productLi.addClass('auction-ending-grayscale');
            }, 400);

            // Phase 3: Banner
            setTimeout(function() {
                productLi.addClass('uwa_auction_status_expired');
                productLi.removeClass('auction-ending-grayscale');
                flash.remove();
            }, 800);
        },

        /**
         * Erzeugt Konfetti-Partikel
         */
        createConfetti: function(container, count) {
            var self = this;
            for (var i = 0; i < count; i++) {
                var confetti = $('<div class="brandner-confetti"></div>');
                confetti.css({
                    left: Math.random() * 100 + '%',
                    top: '-10px',
                    background: this.confettiColors[Math.floor(Math.random() * this.confettiColors.length)],
                    transform: 'rotate(' + (Math.random() * 360) + 'deg)',
                    animationDelay: (Math.random() * 0.5) + 's',
                    animationDuration: (2 + Math.random() * 2) + 's'
                });

                // Verschiedene Formen
                if (Math.random() > 0.5) {
                    confetti.css('borderRadius', '50%');
                } else {
                    confetti.css({
                        width: '8px',
                        height: '12px'
                    });
                }

                container.append(confetti);
                setTimeout(function() {
                    confetti.addClass('active');
                }, 10);

                // Aufraeumen nach Animation
                (function(c) {
                    setTimeout(function() {
                        c.remove();
                    }, 4000);
                })(confetti);
            }
        },

        /**
         * Erzeugt Sparkle-Effekte
         */
        createSparkles: function(container, count) {
            for (var i = 0; i < count; i++) {
                var sparkle = $('<div class="brandner-sparkle"></div>');
                sparkle.css({
                    left: Math.random() * 100 + '%',
                    top: Math.random() * 100 + '%',
                    animationDelay: (Math.random() * 2) + 's'
                });

                container.append(sparkle);
                setTimeout(function() {
                    sparkle.addClass('active');
                }, 10);

                // Wiederholen
                (function(s) {
                    var interval = setInterval(function() {
                        if (!s.closest('body').length) {
                            clearInterval(interval);
                            return;
                        }
                        s.removeClass('active');
                        s.css({
                            left: Math.random() * 100 + '%',
                            top: Math.random() * 100 + '%'
                        });
                        setTimeout(function() {
                            s.addClass('active');
                        }, 50);
                    }, 1500 + Math.random() * 1000);
                })(sparkle);
            }
        },

        /**
         * Zeigt Vollbild-Gewinner-Animation (fuer Single-Product-Seite)
         */
        showFullscreenWinner: function(productTitle, bidAmount) {
            var overlay = $('<div class="brandner-fullscreen-winner-overlay">' +
                '<div class="brandner-glow-ring"></div>' +
                '<div class="brandner-glow-ring"></div>' +
                '<div class="brandner-glow-ring"></div>' +
                '<div class="brandner-fullscreen-winner-content">' +
                '<div class="brandner-fullscreen-trophy">&#127942;</div>' +
                '<div class="brandner-fullscreen-winner-text">Gewonnen!</div>' +
                '<div class="brandner-fullscreen-subtext">' + (productTitle || '') + '</div>' +
                '<div class="brandner-fullscreen-price">' + (bidAmount || '') + '</div>' +
                '<button class="brandner-fullscreen-close-btn">Weiter</button>' +
                '</div>' +
                '</div>');

            $('body').append(overlay);

            // Konfetti
            this.createFullscreenConfetti(150);

            // Animation starten
            setTimeout(function() {
                overlay.addClass('active');
            }, 50);

            // Weitere Konfetti-Wellen
            var self = this;
            setTimeout(function() { self.createFullscreenConfetti(100); }, 1000);
            setTimeout(function() { self.createFullscreenConfetti(80); }, 2000);

            // Close Button
            overlay.find('.brandner-fullscreen-close-btn').on('click', function() {
                overlay.removeClass('active');
                setTimeout(function() {
                    overlay.remove();
                }, 500);
            });

            // ESC zum Schliessen
            $(document).one('keydown', function(e) {
                if (e.key === 'Escape') {
                    overlay.removeClass('active');
                    setTimeout(function() {
                        overlay.remove();
                    }, 500);
                }
            });
        },

        /**
         * Erzeugt Vollbild-Konfetti
         */
        createFullscreenConfetti: function(count) {
            var self = this;
            for (var i = 0; i < count; i++) {
                var confetti = $('<div class="brandner-fullscreen-confetti"></div>');
                confetti.css({
                    left: Math.random() * 100 + 'vw',
                    top: '-20px',
                    background: this.confettiColors[Math.floor(Math.random() * this.confettiColors.length)],
                    animationDelay: (Math.random() * 2) + 's',
                    animationDuration: (3 + Math.random() * 2) + 's'
                });

                if (Math.random() > 0.5) {
                    confetti.css('borderRadius', '50%');
                }

                $('body').append(confetti);
                setTimeout(function() {
                    confetti.addClass('active');
                }, 10);

                (function(c) {
                    setTimeout(function() {
                        c.remove();
                    }, 6000);
                })(confetti);
            }
        }
    };

    // Global verfuegbar machen
    window.BrandnerAuctionAnimations = BrandnerAuctionAnimations;

    // Initialisierung
    $(document).ready(function() {
        BrandnerAuctionAnimations.init();
    });

})(jQuery);
